import { NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, input, Input, InputSignal, linkedSignal, Output, Signal, viewChild, WritableSignal } from '@angular/core';
import { Guid } from 'guid-typescript';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import SignaturePad from 'signature_pad';
import { ActionElementComponent } from '../../../base/action-element';
import { Signature } from '../../../models/signature';
import { TranslationPipe } from '../../../pipes/translation.pipe';

@Component({
  selector: 'app-signature-canvas',
  templateUrl: './signature-canvas.component.html',
  styleUrls: ['./signature.component.scss'],
  imports: [NgTemplateOutlet, TranslationPipe],
})
export class SignatureCanvasComponent extends ActionElementComponent {
  canvas: Signal<ElementRef<HTMLCanvasElement> | undefined> = viewChild('canvas');

  @Input() signature: Signature | undefined;
  inline: InputSignal<boolean> = input<boolean>(false);
  disabled: InputSignal<boolean> = input<boolean>(false);
  disabledState: WritableSignal<boolean> = linkedSignal(() => this.disabled());

  signaturePad: SignaturePad | undefined;

  @Output()
  public onClose: Subject<string>;

  constructor(public bsModalRef: BsModalRef) {
    super();
    this.onClose = new Subject();
    queueMicrotask(() => {
      const canvas = this.canvas();
      if (!canvas) {
        return;
      }
      this.signaturePad = new SignaturePad(canvas.nativeElement);
      if (this.inline()) {
        this.signaturePad.addEventListener('endStroke', (e) => this.stoppedDrawing(e));
      }
    });
  }

  success($event: any): void {
    $event.stopPropagation();
    $event.preventDefault();

    if (!this.signature) {
      return;
    }

    if (this.signature.pageRequests && this.signature.pageRequests.length) {
      for (const pageRequest of this.signature.pageRequests) {
        if (pageRequest.option) {
          pageRequest.option['signature'] = this.signaturePad?.toDataURL();
          pageRequest.option['signatureFileName'] = `signature-${Guid.create().toString()}.png`;
        } else {
          pageRequest.option = {
            signature: this.signaturePad?.toDataURL(),
            fileName: `signature-${Guid.create().toString()}.png`,
          };
        }
      }
    }

    if (this.signature.pageRequests?.length) {
      super.action($event, this.signature);
    } else {
      this.onClose.next(this.signaturePad?.toDataURL() || '');
    }

    this.bsModalRef?.hide();
  }

  stoppedDrawing(_event: any): void {
    const dataUrl = this.signaturePad?.toDataURL() || '';
    this.onClose.next(dataUrl);
  }

  setDisabled(isDisabled: boolean): void {
    this.disabledState.set(isDisabled);
    if (isDisabled) {
      this.signaturePad?.off();
    } else {
      this.signaturePad?.on();
    }
  }
}
